<script>
    import {formatDate} from "../lib/lib.js";

    export let person;
    export let index;

    let address = '';

    $: address = (person.address ? `${person.address}, ` : "") + person.zip + (person.city ? ` ${person.city}` : "");
</script>

<div class="panel panel-default mb-4">
    <div class="panel-heading">
        <h6 class="mb-0">Person { index + 1 }</h6>
    </div>
    <div class="panel-body panel-pad">
        <h5 class="mb-3">{ person.abbr } { person.lastname } { person.firstname }</h5>
        <div class="row">
            <div class="col-xl-4 col-lg-4 col-md-4 col-6 form-group">
                <h6 class="mb-1">Birthday</h6>
                { formatDate(person.birthday, 'd-m-y') }
            </div>
            <div class="col-xl-4 col-lg-4 col-md-4 col-6 form-group">
                <h6 class="mb-1">Phone</h6>
                { person.phone }
            </div>
            <div class="col-xl-4 col-lg-4 col-md-4 form-group">
                <h6 class="mb-1">Email</h6>
                { person.email }
            </div>
            {#if person.address}
                <div class="col-xl-4 col-lg-4 col-md-4 col-12 form-group">
                    <h6 class="mb-1">Address</h6>
                    { person.address }
                </div>
            {/if}
            <div class="col-xl-4 col-lg-4 col-md-4 col-6 form-group">
                <h6 class="mb-1">Passport id</h6>
                { person.passport_id }
            </div>
            <div class="col-xl-4 col-lg-4 col-md-4 col-6 form-group">
                <h6 class="mb-1">Nationality</h6>
                { person.country }
            </div>
        </div>
    </div>
</div>
